<section class="grid grid-cols-1 gap-y-12 px-4 py-12 sm:px-5 md:py-16 lg:grid-cols-24 lg:px-0 lg:py-20">
  <div class="lg:col-span-10 lg:col-start-2">
    <p class="text-sm font-semibold uppercase tracking-[0.2em] text-blue-700 font-['Inter']">
      Dados de leilão atualizados todo dia
    </p>
    <h1 class="mt-8 text-4xl font-bold leading-tight text-gray-900 sm:text-5xl md:text-6xl">
      Saiba se o leilão <span class="text-blue-600">vale</span><br class="hidden sm:block">
      <span class="text-blue-600"> a pena</span> antes de dar<br class="hidden sm:block">
      o lance
    </h1>
    <p class="mt-6 max-w-2xl text-lg font-normal leading-relaxed text-gray-500 sm:text-xl font-['Inter']">
      A Casato reúne imóveis de diferentes fontes e organiza as informações mais importantes, como custos, entorno e possíveis riscos, em um só lugar. Assim, você analisa com mais clareza antes de decidir, seja para morar ou investir.
    </p>

    <div class="mt-10 flex flex-col gap-3 sm:flex-row sm:items-center">
      <a
        routerLink="/planos"
        class="inline-flex items-center justify-center rounded-md bg-blue-700 px-5 py-2.5 text-sm font-medium text-white hover:bg-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-300">
        Começar teste grátis
      </a>
      <a
        routerLink="/planos"
        class="inline-flex items-center justify-center rounded-md border border-gray-300 bg-white px-5 py-2.5 text-sm font-medium text-gray-900 hover:bg-gray-100 focus:outline-none focus:ring-4 focus:ring-gray-100">
        Ver planos
        <svg class="ms-2 h-3.5 w-3.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 5h12m0 0L9 1m4 4L9 9"/>
        </svg>
      </a>
    </div>

    <p class="mt-4 text-sm font-medium leading-relaxed text-gray-500 font-['Inter']">
      7 dias grátis · cancele quando quiser
    </p>
  </div>

  <div class="lg:col-span-11 lg:col-start-13">
    <div class="hero-preview relative overflow-hidden rounded-[2rem] border border-blue-100 bg-white p-3 shadow-[0px_18px_45px_rgba(37,99,235,0.10)] md:p-5">
      <div class="hero-preview-map relative h-[500px] rounded-[2rem] border border-blue-100 bg-slate-50">
        <div class="hero-watermark"></div>
        <div class="hero-map-point left-[12%] top-[18%]"></div>
        <div class="hero-map-point left-[31%] top-[34%]"></div>
        <div class="hero-map-point left-[58%] top-[22%]"></div>
        <div class="hero-map-point left-[83%] top-[48%]"></div>
        <div class="hero-map-point left-[37%] top-[76%]"></div>
        <div class="hero-map-point left-[68%] top-[82%]"></div>

        <div class="hero-pin z-[2] left-[20%] top-[26%]"></div>
        <div class="hero-pin z-[2] left-[74%] top-[61%]"></div>

        <div class="hero-float-badge z-[4] left-[69%] top-[42%] hidden md:flex">
          <span class="hero-float-icon hero-float-icon--ring"></span>
          Risco analisado
        </div>

        <div class="hero-float-badge z-[4] bottom-[18%] left-[4%] hidden md:flex">
          <span class="hero-float-icon hero-float-icon--chart"></span>
          Lucro estimado <span class="ms-2 text-green-600">+R$ 96 mil</span>
        </div>

        <div class="absolute z-[3] left-1/2 top-1/2 w-[72%] max-w-[30rem] -translate-x-1/2 -translate-y-1/2 rounded-[1.75rem] bg-white p-6 shadow-[0px_20px_45px_rgba(15,23,42,0.14)] md:p-8">
          <p class="text-center text-[1.35rem] font-semibold leading-tight text-gray-900 font-['Inter'] md:text-2xl">
            Apartamento • São Paulo, SP
          </p>

          <div class="mt-7 border-b border-gray-200 pb-6 text-center md:mt-8">
            <p class="text-sm font-medium uppercase tracking-[0.14em] text-gray-500 font-['Inter']">
              Valor avaliado
            </p>
            <p class="mt-2 text-3xl font-semibold leading-tight text-indigo-500 font-['Inter'] md:text-4xl">
              R$ 350.000,00
            </p>
          </div>

          <div class="py-5 text-center md:py-6">
            <p class="text-3xl font-bold leading-none tracking-[-0.03em] text-gray-900 font-['Inter'] md:text-4xl">
              R$ 221.208,04
            </p>
          </div>

          <div class="space-y-3.5 border-b border-gray-200 pb-6">
            <div class="flex items-center justify-between gap-4 text-sm font-normal leading-snug text-gray-700 font-['Inter'] md:text-base">
              <span>1º Leilão · 13/07/26</span>
              <span class="font-semibold text-gray-900">R$ 350.000,00</span>
            </div>
            <div class="flex items-center justify-between gap-4 text-sm font-normal leading-snug text-gray-700 font-['Inter'] md:text-base">
              <span>2º Leilão · 17/07/26</span>
              <span class="inline-flex items-center rounded-lg bg-green-100 px-2.5 py-1 text-sm font-semibold text-green-700">
                <svg class="me-1 h-3.5 w-3.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19V5m0 14-4-4m4 4 4-4"/>
                </svg>
                37%
              </span>
            </div>
          </div>

          <span
            class="mt-6 inline-flex w-full cursor-default items-center justify-center rounded-[1.5rem] bg-blue-700 px-5 py-4 text-base font-medium text-white md:text-lg"
            aria-disabled="true">
            Ver mais informações
          </span>
        </div>
      </div>
    </div>
  </div>
</section>
